module.exports = __webpack_public_path__ + "img/1521800238.0cbe9f9d.jpg";